import { render, staticRenderFns } from "./FormComponent.vue?vue&type=template&id=1892610c&scoped=true"
import script from "./FormComponent.vue?vue&type=script&lang=js"
export * from "./FormComponent.vue?vue&type=script&lang=js"
import style0 from "./FormComponent.vue?vue&type=style&index=0&id=1892610c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1892610c",
  null
  
)

export default component.exports